import { Flex, Heading, Text, useBreakpointValue } from "@chakra-ui/react"
import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";
import { ContactInfo } from "./Contact";

interface Props {
	// Used for the browser tab, and the page header unless `heading` is set
	title: string;
	// Page header text, when it should differ from the tab title
	heading?: string;
	subtitle?: string;
	// Show the contact info (phone, address, map) at the bottom of the page
	showContact?: boolean;
	children?: React.ReactNode;
}

// Wrapper for inner pages: sets the page title, shows it as a header, ends with the
// contact info, and fills the space between the navbar and footer so the footer stays at the bottom
export default function Page(props: Props) {
	const { title, heading, subtitle, showContact = true, children } = props;

	usePageTitle(title);

	const titleFontSize = useBreakpointValue({ base: "36px", md: "44px", lg: "52px" });

	return (
		<Flex
			flex={1}
			flexDirection={"column"}
			width={"100%"}
		>
			{/* Page Header */}
			<Flex
				flexDirection={"column"}
				alignItems={"center"}
				gap={2}
				paddingX={4}
				paddingY={{ base: 6, md: 10 }}
			>
				<Heading
					as={"h1"}
					textAlign={"center"}
					fontFamily={"Martel"}
					fontWeight={"700"}
					fontSize={titleFontSize}
					color={"white.500"}
				>
					{heading ?? title}
				</Heading>

				{subtitle && (
					<Text
						width={{ base: "100%", md: "80%" }}
						textAlign={"center"}
						fontFamily={"Montserrat"}
						fontWeight={"500"}
						fontSize={"18px"}
						color={"white.500"}
					>
						{subtitle}
					</Text>
				)}
			</Flex>

			{children}

			{/* Contact Info */}
			{showContact && (
				<Flex
					// Pushed to the bottom of the page, just above the footer
					marginTop={"auto"}
					width={"100%"}
					flexDirection={"column"}
					alignItems={"center"}
					gap={5}
					paddingY={{ base: 10, md: 16 }}
				>
					<Heading
						as={"h2"}
						textAlign={"center"}
						fontFamily={"Martel"}
						fontWeight={"700"}
						fontSize={{ base: "24px", md: "28px" }}
						color={"white.500"}
					>
						Contact Joe
					</Heading>

					<ContactInfo />
				</Flex>
			)}
		</Flex>
	);
}
